<template>
  <section class="venue-mega-menu" :style="{backgroundImage:`url(${referenceAsset('sport-main','bg0')})`}" aria-label="导航场馆" @mouseenter="$emit('enter')" @mouseleave="$emit('leave')">
    <div class="container venue-mega-carousel">
      <div ref="track" class="venue-mega-list" :class="{ 'is-dragging': dragging }" tabindex="0" aria-label="场馆列表，可左右滑动" @scroll="updateScroll" @wheel="scrollWheel" @keydown.left.self.prevent="scrollByCard(-1)" @keydown.right.self.prevent="scrollByCard(1)" @pointerdown="startDrag" @pointermove="moveDrag" @pointerup="endDrag" @pointercancel="endDrag" @lostpointercapture="endDrag">
        <article v-for="(venue,index) in venues" :key="venue.id">
          <img class="venue-mega-art" :src="resolveVenueBrand(presentation.key,venue)?.artwork ? venueBrandAsset(resolveVenueBrand(presentation.key,venue).artwork) : referenceAsset(presentation.key,presentation.artwork[index % presentation.artwork.length])" alt="" draggable="false" />
          <div>
            <span v-if="/^\d+(?:\.\d+)?$/.test(String(venue.rebateRate ?? ''))" class="venue-mega-rebate">高达{{ venue.rebateRate }}% 无限返水</span>
            <b :title="venue.name">{{ venue.name }}</b>
            <small>{{ venue.venueType }}</small>
            <button @click="open(venue)">进入游戏</button>
          </div>
        </article>
        <p v-if="!venues.length">当前分类暂无可用场馆</p>
      </div>
      <template v-if="canScroll">
        <button class="venue-mega-scroll previous" aria-label="向左查看场馆" :disabled="atStart" @click="scrollByCard(-1)"><SiteIcon name="caret-down" :size="20" /></button>
        <button class="venue-mega-scroll next" aria-label="向右查看场馆" :disabled="atEnd" @click="scrollByCard(1)"><SiteIcon name="caret-down" :size="20" /></button>
      </template>
    </div>
  </section>
</template>
<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import SiteIcon from '../SiteIcon.vue'
import { resolveVenueBrand, venueBrandAsset } from '../../config/venueBrandPresentation.js'
import { gamePresentations, referenceAsset } from '../../config/referencePresentation.js'
import { useAppContext } from '../../composables/appContext'
const props=defineProps({ path:{type:String,required:true} })
const emit=defineEmits(['enter','leave','close'])
const { availableVenues, openVenueGames, navigate, isLoggedIn, openAuth }=useAppContext()
const presentation=computed(()=>gamePresentations[props.path])
const venues=computed(()=>(availableVenues.value || []).filter(v=>v.categoryPath===props.path))
const track=ref(null)
const canScroll=ref(false)
const atStart=ref(true)
const atEnd=ref(true)
const dragging=ref(false)
let dragStart=null
let resizeObserver
function updateScroll(){
  const element=track.value
  if(!element)return
  canScroll.value=element.scrollWidth>element.clientWidth+1
  atStart.value=element.scrollLeft<=1
  atEnd.value=element.scrollLeft+element.clientWidth>=element.scrollWidth-1
}
function scrollByCard(direction){
  const element=track.value
  if(!element)return
  const width=element.querySelector('article')?.getBoundingClientRect().width || element.clientWidth
  element.scrollBy({left:direction*width,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})
}
function scrollWheel(event){
  if(!canScroll.value || Math.abs(event.deltaX)>=Math.abs(event.deltaY))return
  if((event.deltaY<0 && atStart.value) || (event.deltaY>0 && atEnd.value))return
  event.preventDefault()
  const delta=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?track.value.clientWidth:1)
  track.value.scrollLeft+=delta
}
function startDrag(event){
  if(event.pointerType!=='mouse' || event.button!==0 || !canScroll.value || event.target.closest('button'))return
  dragStart={x:event.clientX,left:track.value.scrollLeft}
  track.value.setPointerCapture(event.pointerId)
}
function moveDrag(event){
  if(!dragStart)return
  const distance=event.clientX-dragStart.x
  if(Math.abs(distance)>4)dragging.value=true
  if(dragging.value)track.value.scrollLeft=dragStart.left-distance
}
function endDrag(){dragStart=null;dragging.value=false}
watch([()=>props.path,venues],async()=>{
  await nextTick()
  endDrag()
  if(track.value)track.value.scrollLeft=0
  updateScroll()
})
onMounted(()=>{resizeObserver=new ResizeObserver(updateScroll);resizeObserver.observe(track.value);updateScroll()})
onBeforeUnmount(()=>resizeObserver?.disconnect())
function open(venue){emit('close');if(!isLoggedIn.value){openAuth('login');return}navigate(props.path);openVenueGames(venue)}
</script>
